module.exports = __webpack_public_path__ + "img/otherpay.41ab5407.svg";